function arrayize( el ) {
  if ( ! el ) return []

  if ( el instanceof Array ) return [ ...el ]

  return [ el ]
}

export default arrayize
